import React, { useMemo, useState } from "react";
import parse from "html-react-parser";

function ReadMoreContent({ content, maxLength = 500, themeColor }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentString = useMemo(() => String(content || ""), [content]);
  const isLongContent = contentString.length > maxLength;

  return (
    <div>
      {isExpanded
        ? parse(contentString)
        : parse(
            contentString.substring(0, maxLength) +
              (isLongContent ? "..." : "")
          )}
      {isLongContent && (
        <button
          onClick={() => setIsExpanded((prevState) => !prevState)}
          style={{
            background: "none",
            border: "none",
            color: themeColor,
            cursor: "pointer",
            marginTop: "10px",
            fontWeight: "600",
          }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      )}
    </div>
  );
}

export default ReadMoreContent;
